module.exports = __webpack_public_path__ + "site_static/img/channel1.0ec0660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channel1.png
// module id = SB/h
// module chunks = 0